(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // 获取轮播元素
  const slides = document.querySelectorAll('.custom-services__slide');
  const prevButton = document.querySelector('.slider-button--prev');
  const nextButton = document.querySelector('.slider-button--next');
  
  if (slides.length <= 1) {
    // 如果只有一张幻灯片则隐藏导航按钮
    if (prevButton) prevButton.style.display = 'none';
    if (nextButton) nextButton.style.display = 'none';
    return;
  }
  
  let currentSlide = 0;
  
  // 更新轮播的函数
  function showSlide(index) {
    // 移除所有幻灯片的活动类
    slides.forEach(slide => {
      slide.classList.remove('active');
    });
    
    // 为当前幻灯片添加活动类
    slides[index].classList.add('active');
  }
  
  // 上一张按钮点击事件
  prevButton.addEventListener('click', function() {
    currentSlide = (currentSlide - 1 + slides.length) % slides.length;
    showSlide(currentSlide);
  });
  
  // 下一张按钮点击事件
  nextButton.addEventListener('click', function() {
    currentSlide = (currentSlide + 1) % slides.length;
    showSlide(currentSlide);
  });
  
  // 每5秒自动轮播幻灯片
  let autoSlide = setInterval(function() {
    currentSlide = (currentSlide + 1) % slides.length;
    showSlide(currentSlide);
  }, 5000);
  
  // 悬停在轮播上时暂停自动轮播
  const slider = document.querySelector('.custom-services__image-container');
  if (slider) {
    slider.addEventListener('mouseenter', function() {
      clearInterval(autoSlide);
    });
    
    // 鼠标离开时恢复自动轮播
    slider.addEventListener('mouseleave', function() {
      autoSlide = setInterval(function() {
        currentSlide = (currentSlide + 1) % slides.length;
        showSlide(currentSlide);
      }, 5000);
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
